import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Framework7 from 'framework7/framework7.esm.bundle.js'
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'
import 'framework7/css/framework7.bundle.min.css'
import * as filters from './filters.js'

Framework7.use(Framework7Vue)
Vue.use(VueAxios, axios);
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

new Vue({
    store,
    render: h => h(App)
}).$mount('#app')